module.exports = __webpack_public_path__ + "assets/img/24.cdcdd0d6.png";